/**
 * F-155: the *Place video* cell of a Short filled from Local Files. Nothing is
 * uploaded: the host lets the user pick the finished video and MOVES it into
 * the script's folder, named after the script (`Ep12.csv` → `Ep12.mp4`). The
 * script's path is the cell above's text (`script-header.ts`).
 *
 * Only the desktop app can move files; elsewhere the button says so.
 */
import { useState } from "react";

import { hostVideoPlacer } from "../../core/host.js";
import { showToast } from "../../ui/toast.js";
import { pathBaseName } from "./script-header.js";

export function PlaceVideoButton({ scriptPath }: { scriptPath: string }) {
  const place = hostVideoPlacer();
  const [busy, setBusy] = useState(false);
  const path = scriptPath.trim();
  const tip =
    place === null
      ? "Placing the video works in the Rainvic desktop app"
      : path === ""
        ? "The row above needs the script's path"
        : `Move a video next to ${pathBaseName(path)}, named after it`;

  const run = async () => {
    if (place === null || path === "" || busy) return;
    setBusy(true);
    try {
      const result = await place(path);
      if (result.path !== undefined) showToast(`Placed ${pathBaseName(result.path)} next to the script.`);
      else if (result.cancelled !== true) showToast(result.error ?? "The video could not be moved.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className="btn btn-primary place-video-btn"
      disabled={place === null || path === "" || busy}
      data-tip={tip}
      // The grid selects on pointerdown and edits on double-click — neither here.
      onPointerDown={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        void run();
      }}
    >
      {busy ? "Placing…" : "▶ Place video"}
    </button>
  );
}
